module.exports = __webpack_public_path__ + "assets/learn-2.1fc8d01e.svg";